import { useMemo } from 'react'

import { extractPartsFromUserName } from 'features/views/attributes/utils'

type UseProfileImageAttributeStateProps = {
    profileImageValue?: unknown
    profileImageField?: FieldDto
    titleValue?: unknown
    titleField?: FieldDto
}

export function useProfileImageAttributeState({
    profileImageValue,
    profileImageField,
    titleValue,
    titleField,
}: UseProfileImageAttributeStateProps) {
    const hasField = !!profileImageField

    const imageSrc = extractSrcFromFieldValue(profileImageField, profileImageValue)

    const recordTitle = extractTitleFromFieldValue(titleField, titleValue)
    const { firstName, lastName } = extractPartsFromUserName(recordTitle)

    const hasThumbnail = hasField && !!recordTitle

    return useMemo(
        () => ({
            hasThumbnail,
            imageSrc,
            firstName,
            lastName,
        }),
        [imageSrc, hasThumbnail, firstName, lastName]
    )
}

function extractSrcFromFieldValue(field?: FieldDto, value?: unknown) {
    if (!field) return undefined

    // Extract the URL from the attachment value.
    if (field.type === 'multi_file') {
        if (Array.isArray(value)) {
            return value[0]?.url
        } else if (value && typeof value === 'object') {
            return (value as any).url
        }
    }

    return undefined
}

function extractTitleFromFieldValue(field?: FieldDto, value?: unknown) {
    if (!field && typeof value === 'string') {
        return value
    } else if (!field) {
        return undefined
    }

    if (typeof value === 'object' && field.type === 'document') {
        return (value as any).plainTextContent
    }

    return value?.toString()
}
